import React, { useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

/**
 * AddSpeakerModal Component
 * 
 * Modal for adding a new speaker to the transcript
 */
const AddSpeakerModal = ({ isOpen, onClose, onAdd }) => {
  const [speakerName, setSpeakerName] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const trimmedName = speakerName.trim();
    
    if (!trimmedName) {
      setError('Speaker name cannot be empty');
      return;
    }
    
    if (trimmedName.length < 2) {
      setError('Speaker name must be at least 2 characters');
      return;
    }
    
    onAdd(trimmedName);
    setSpeakerName('');
    setError('');
    onClose();
  };

  const handleClose = () => {
    setSpeakerName('');
    setError('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
      style={{ zIndex: 100000 }}
    >
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900">Add New Speaker</h3>
          <button
            onClick={handleClose}
            className="p-1 hover:bg-gray-100 rounded transition-colors"
          >
            <XMarkIcon className="h-5 w-5 text-gray-500" />
          </button>
        </div>

        {/* Content */}
        <form onSubmit={handleSubmit} className="p-4 space-y-4">
          <div>
            <label htmlFor="speaker-name" className="block text-sm font-medium text-gray-700 mb-1">
              Speaker Name
            </label>
            <input
              id="speaker-name"
              type="text"
              value={speakerName}
              onChange={(e) => {
                setSpeakerName(e.target.value);
                setError('');
              }}
              placeholder="Enter speaker name"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              autoFocus
            />
            {error && (
              <p className="mt-1 text-sm text-red-600">{error}</p>
            )}
          </div>

          {/* Actions */}
          <div className="flex justify-end gap-2 pt-2">
            <button
              type="button"
              onClick={handleClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors"
            >
              Add Speaker
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddSpeakerModal;

